<span [class]="'badge ' + getVariantClass()">
  {{ text() }}
</span>
